import { render, staticRenderFns } from "./Teacher.vue?vue&type=template&id=349812aa&scoped=true&lang=pug&"
import script from "./Teacher.vue?vue&type=script&lang=ts&"
export * from "./Teacher.vue?vue&type=script&lang=ts&"
import style0 from "./Teacher.vue?vue&type=style&index=0&id=349812aa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349812aa",
  null
  
)

export default component.exports